// frontend/src/components/homepage/artefacts/SupporterNet.js
//
// Tile 04's artefact: four supporter nodes tied to a pulsing centre by dashed
// lines that crawl (`hl-dash`, `hl-pulseC`). A literal port of the prototype's
// `.art-net` SVG. No ids in this SVG, so nothing to prefix.

import React, { memo } from "react";

export const NET_LABEL = "ממליצים";

function SupporterNet() {
  return (
    <svg viewBox="0 0 220 160" aria-hidden="true">
      <line x1="110" y1="80" x2="40" y2="30" />
      <line x1="110" y1="80" x2="180" y2="40" />
      <line x1="110" y1="80" x2="60" y2="130" />
      <line x1="110" y1="80" x2="170" y2="125" />
      <circle cx="40" cy="30" r="9" />
      <circle cx="180" cy="40" r="9" />
      <circle cx="60" cy="130" r="9" />
      <circle cx="170" cy="125" r="9" />
      <circle className="hl-ft-c" cx="110" cy="80" r="10" />
      <text x="110" y="110" textAnchor="middle">
        {NET_LABEL}
      </text>
    </svg>
  );
}

export default memo(SupporterNet);
